export const initialState = {
  user: null,
  role: null,
};

export const actionTypes = {
  SET_USER: "SET_USER",
  SET_ROLE: "SET_ROLE",
};

const reducer = (state, action) => {
  // console.log(action);
  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.user,
        role: action.role,
      };
    default:
      return state;
  }
};

export default reducer;
